<div class="qa-tab-container">
  <p-selectButton class="qa-role" [options]="stateOptions" [(ngModel)]="qaRole"></p-selectButton>
  <app-gbp-qa-customer-view *ngIf="qaRole == 'Customer'; else owner"></app-gbp-qa-customer-view>

  <ng-template #owner><app-gbp-qa-owner-view></app-gbp-qa-owner-view></ng-template>
</div>
